import axiosInstance from "config/axiosConfig";
import { putFileToPresignedUrl } from "../../../shared/presigned-upload";

interface UploadRequest {
  filename: string;
  applicationId: string;
  documentType: string;
}

export interface PresignedUrlResponse {
  applicationId: string;
  fileName: string;
  fileUploadUrl: string;
}

export const API_PATHS = {
  FILE_UPLOAD: "/upload/",
  FILE_DOWNLOAD: "/download/",
};

// Function to request presigned URL
export const getPresignedUrl = async (uploadRequest: UploadRequest) => {
  try {
    const response = await axiosInstance.post<PresignedUrlResponse>(
      API_PATHS.FILE_UPLOAD,
      uploadRequest
    );
    return response.data;
  } catch (error) {
    console.error("Error getting presigned URL:", error);
    throw new Error("Failed to get presigned URL");
  }
};

// Retries transient failures; see shared/presigned-upload.ts.
export const uploadFileToPresignedUrl = async (
  file: File,
  presignedUrl: string,
  onProgress: (progress: number) => void
) => {
  try {
    await putFileToPresignedUrl(file, presignedUrl, { onProgress });
  } catch (error) {
    console.error("Error during file upload:", error);
    throw error;
  }
};

// Service to fetch the file from S3 using the presigned URL
export const fetchFileFromS3 = async (presignedUrl: string) => {
  try {
    const response = await axiosInstance.get(presignedUrl, {
      responseType: "blob",
    });

    const fileBlob = response.data;
    const fileURL = URL.createObjectURL(fileBlob);
    return fileURL;
  } catch (error) {
    console.error("Error fetching file from S3:", error);
    throw error;
  }
};

// Service to fetch the presigned URL and object key
export const getPresignedUrlFromApplicationId = async (
  applicationId: string
) => {
  try {
    const response = await axiosInstance.post(API_PATHS.FILE_DOWNLOAD, {
      applicationId,
    });
    return response.data; // This will return { presignedUrl, objectKey }
  } catch (error) {
    console.error("Error fetching presigned URL:", error);
    throw error;
  }
};
